// component names in Contentful CMS
export const ContentfulSideBySideInputFieldComponent = 'ContentfulSideBySideInputField'
export const ContentfulTextInputFieldComponent = 'ContentfulTextInputField'
export const ContentfulRadioCheckBoxFieldComponent = 'ContentfulRadioCheckBoxField'
export const ContentfulDropdownFieldComponent = 'ContentfulDropdownField'
export const ContentfulStaticInformationFieldComponent = 'ContentfulStaticInformationField'
export const ContentfulRightSideContentViewComponent = 'ContentfulRightSideContentView'
export const ContentfulLeftSideContentViewComponent = 'ContentfulLeftSideContentView'

// names of business form fields in contentful
export const ContentfulBusinessIdFieldName = 'businessId'
export const ContentfulBusinessNameFieldName = 'businessName'
export const ContentfulBusinessPhoneNumberFieldName = 'businessPhoneNumber'
export const ContentfulBusinessMarketingNameFieldName = 'businessMarketingName'
export const ContentfulBusinessLocationAddressFieldName = 'businessLocationAddress'
export const ContentfulBusinessLocationCityFieldName = 'businessLocationCity'
export const ContentfulBusinessLocationPostalCodeFieldName = 'businessLocationPostCode'
export const ContentfulBusinessContactPersonFirstNameFieldName = 'businessContactPersonFirstName'
export const ContentfulBusinessContactPersonLastNameFieldName = 'businessContactPersonLastName'
export const ContentfulBusinessContactPersonEmailFieldName = 'businessContactPersonEmail'
export const ContentfulBusinessContactPersonPhoneNumberFieldName = 'businessContactPersonPhoneNumber'
export const ContentfulBusinessIndustryFieldName = 'businessIndustry'
export const ContentfulBusinessDeliveryDeliveringPlantFieldName = 'businessDeliveryDeliveringPlant'
export const ContentfulBusinessServiceOptionFieldName = 'businessServiceOption'
export const ContentfulBusinessYearlyProcurementEstimateFieldName = 'businessYearlyProcurementEstimate'
export const ContentfulBusinessPaymentMethodFieldName = 'businessPaymentMethod'
export const ContentfulBusinessPrivacyPolicyFieldName = 'businessPrivacyPolicy'
export const ContentfulBusinessMarketingPermissionFieldName = 'businessMarketingPermission'
export const ContentfulBusinessAdditionalInformationFieldName = 'businessAdditionalInformation'

// names of person form fields in contentful
export const ContentfulPersonFirstNameFieldName = 'personFirstName'
export const ContentfulPersonLastNameFieldName = 'personLastName'
export const ContentfulPersonEmailFieldName = 'personEmail'
export const ContentfulPersonPhoneNumberFieldName = 'personPhoneNumber'
export const ContentfulPersonLocationAddressFieldName = 'personDeliveryAddress'
export const ContentfulPersonLocationPostalCodeFieldName = 'personLocationPostCode'
export const ContentfulPersonLocationCityFieldName = 'personPlaceOfActivity'
export const ContentfulPersonDeliveryDeliveringPlantFieldName = 'personDeliveryDeliveringPlant'
export const ContentfulPersonMarketingPermissionFieldName = 'personMarketingPermission'
export const ContentfulPersonTermsOfUseFieldName = 'personTermsOfUse'

// names of customer types in contentful
export const businessCustomerType = 'businessCustomer'
export const personCustomerType = 'personCustomer'

// names of language locale fields
export const businessLanguage = 'businessLanguage'
export const personLanguage = 'personLanguage'

// name of captcha value field
export const CaptchaValueFieldName = 'reCaptchaToken'

// maximum character number in textarea field
export const MAX_CHARACTER_COUNT = 500

// default marketing permission value
export const BUSINESS_MARKETING_PERMISSION_DEFAULT = null
export const PERSON_MARKETING_PERMISSION_DEFAULT = false

// responsive view width breakpoint for mobile devices in pixels
export const RESPONSIVE_SCREEN_WIDTH_MEDIUM = 768
export const RESPONSIVE_SCREEN_WIDTH_LARGE = 960

// validations
export const EmailValidationType = 'Email'
// eslint-disable-next-line no-useless-escape
export const EmailValidation = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export const EmailValidationInputPattern =
    "[a-zA-ZÅÄÖåäö0-9.!#$%&'*+-/=?^_`{|}~]+@[a-zA-ZÅÄÖåäö0-9.-]+[.]{1}[a-zA-ZÅÄÖåäö0-9]{2,}"

export const PhoneNumberValidationType = 'Phone number'
export const PhoneNumberValidation = /^[+]{0,1}[0-9]{6,15}$/
export const PhoneNumberValidationInputPattern = '[+]{0,1}[0-9]{6,15}'

export const TextValidationType = 'Text'
export const TextValidation = /^[a-zA-ZÅÄÖåäö-]*$/
export const TextValidationInputPattern = '[a-zA-ZÅÄÖåäö-]*'

export const TextWithSpaceValidationType = 'Text with spaces'
export const TextWithSpaceValidation = /^[a-zA-ZÅÄÖåäö-\s]*$/
// eslint-disable-next-line no-useless-escape
export const TextWithSpaceValidationInputPattern = '[a-zA-ZÅÄÖåäö-\s]*'

export const AlphanumericTextValidationType = 'Alphanumeric text'
export const AlphanumericTextValidation = /^[0-9a-zA-ZÅÄÖåäö-]*$/
export const AlphanumericTextValidationInputPattern = '[0-9a-zA-ZÅÄÖåäö-]*'

export const AlphanumericTextWithSpaceValidationType = 'Alphanumeric text'
export const AlphanumericTextWithSpaceValidation = /^[0-9a-zA-ZÅÄÖåäö-\s]*$/
// eslint-disable-next-line no-useless-escape
export const AlphanumericTextWithSpaceValidationInputPattern = '[0-9a-zA-ZÅÄÖåäö-\s]*'

export const AlphanumericTextWithSpaceSlashValidationType = 'Alphanumeric text'
export const AlphanumericTextWithSpaceSlashValidation = /^[0-9a-zA-ZÅÄÖåäö-\s/]*$/
// eslint-disable-next-line no-useless-escape
export const AlphanumericTextWithSpaceSlashValidationInputPattern = '[0-9a-zA-ZÅÄÖåäö-\s/]*'

// eslint-disable-next-line no-useless-escape
export const AlphanumericTextWithSpaceDotValidation = /^[0-9a-zA-ZÅÄÖåäö-\s\.]*$/

// eslint-disable-next-line no-useless-escape
export const AlphanumericTextWithSpaceDotEuroValidation = /^[0-9a-zA-ZÅÄÖåäö-\s\.€]*$/

export const BusinessIdValidationType = 'Business ID'
export const BusinessIdValidation = /(^[0-9]{7})-([0-9]{1})$/
export const BusinessIdValidationInputPattern = '[0-9]{7}-[0-9]{1}'

export const NumberValidationType = 'Number'
export const NumberValidation = /(^[0-9]*)$/
export const NumberValidationInputPattern = '[0-9]*'

export const PostalCodeValidationType = 'Postal code'
export const PostalCodeValidation = /(^[0-9]{5})$/
export const PostalCodeValidationInputPattern = '[0-9]{5}'

export const RecaptchaValidation = /^[0-9a-zA-ZÅÄÖåäö_-]*$/

// form fields mapped to their validation patterns
export const fieldPatterns = {
    [ContentfulBusinessIdFieldName]: BusinessIdValidation,
    [ContentfulBusinessNameFieldName]: AlphanumericTextWithSpaceDotValidation,
    [ContentfulBusinessPhoneNumberFieldName]: PhoneNumberValidation,
    [ContentfulBusinessMarketingNameFieldName]: AlphanumericTextWithSpaceValidation,
    [ContentfulBusinessLocationAddressFieldName]: AlphanumericTextWithSpaceDotValidation,
    [ContentfulBusinessLocationCityFieldName]: TextValidation,
    [ContentfulBusinessLocationPostalCodeFieldName]: PostalCodeValidation,
    [ContentfulBusinessContactPersonFirstNameFieldName]: TextWithSpaceValidation,
    [ContentfulBusinessContactPersonLastNameFieldName]: TextWithSpaceValidation,
    [ContentfulBusinessContactPersonEmailFieldName]: EmailValidation,
    [ContentfulBusinessContactPersonPhoneNumberFieldName]: PhoneNumberValidation,
    [ContentfulBusinessIndustryFieldName]: AlphanumericTextWithSpaceSlashValidation,
    [ContentfulBusinessDeliveryDeliveringPlantFieldName]: TextValidation,
    [ContentfulBusinessServiceOptionFieldName]: AlphanumericTextWithSpaceDotEuroValidation,
    [ContentfulBusinessYearlyProcurementEstimateFieldName]: AlphanumericTextWithSpaceDotEuroValidation,
    [ContentfulBusinessPaymentMethodFieldName]: TextValidation,
    [ContentfulBusinessMarketingPermissionFieldName]: NumberValidation,
    [ContentfulBusinessPrivacyPolicyFieldName]: TextValidation,
    [CaptchaValueFieldName]: RecaptchaValidation,

    [ContentfulPersonFirstNameFieldName]: TextWithSpaceValidation,
    [ContentfulPersonLastNameFieldName]: TextWithSpaceValidation,
    [ContentfulPersonEmailFieldName]: EmailValidation,
    [ContentfulPersonPhoneNumberFieldName]: PhoneNumberValidation,
    [ContentfulPersonLocationAddressFieldName]: AlphanumericTextWithSpaceDotValidation,
    [ContentfulPersonLocationPostalCodeFieldName]: PostalCodeValidation,
    [ContentfulPersonLocationCityFieldName]: TextValidation,
    [ContentfulPersonDeliveryDeliveringPlantFieldName]: TextValidation,
    [ContentfulPersonMarketingPermissionFieldName]: NumberValidation,
    [ContentfulPersonTermsOfUseFieldName]: TextValidation
}
